import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import moment from 'moment';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../../Util/Session/session.service';

@Component({
  selector: 'app-expense-trip-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './expense-trip-form.component.html',
  styleUrl: './expense-trip-form.component.scss'
})
export class ExpenseTripFormComponent {
  isDisabled: boolean = false;
  @Input() ID!: number;

  Data = {
    SelectType: 'I',
    ESS_TripMasterID: null as any,
    TripName: null,
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    Description: null as any,
    EmpMasterId : null,
  }

  constructor(
    private activeModal: NgbActiveModal,
    private expense: ExpenseService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private toast: ToastService,
    private session: SessionService,
  ) { 
     this.Data.EmpMasterId = this.session.GetUserDetails().UserId;
  }

  ngOnInit(): void {
    this.Data.ESS_TripMasterID = this.ID;
    if(this.Data.ESS_TripMasterID == undefined){
      this.Data.ESS_TripMasterID = 0;
    }
    if (this.ID > 0) {
      this.ESS_TripMaster_SelectUpdate();
    }
  }

  Verification(form: any) {
    if (form.valid) {
      if ((moment(this.dateFormat.format(this.Data.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Data.FromDateObj), 'DD MMM YYYY')))) {
        this.ESS_TripMaster_InsertUpdate();
      } else {
        this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_TripMaster_InsertUpdate() {
    this.isDisabled = true;
    this.Data.FromDate = this.dateFormat.format(this.Data.FromDateObj);
    this.Data.ToDate = this.dateFormat.format(this.Data.ToDateObj);
    this.expense.ESS_TripMaster_InsertUpdate(this.Data).subscribe({
      next: (response) => {
        if (response.Error_Code == "461") {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.close(true);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_TripMaster_SelectUpdate() {
    this.isDisabled = true;
    this.expense.ESS_TripMaster_SelectUpdate({ SelectType: 'S', ESS_TripMasterID: this.Data.ESS_TripMasterID,EmpMasterId : this.session.GetUserDetails().UserId }).subscribe({
      next: (response) => {
        this.Data = response.Table[0];
        this.Data.FromDateObj = this.dateFormat.parse(this.Data.FromDate);
        this.Data.ToDateObj = this.dateFormat.parse(this.Data.ToDate);
        this.Data.SelectType = 'U';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(result = false) {
    this.activeModal.close(result);
  }
}
